"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactHotkeys = require("react-hotkeys");

var _reactResizeDetector = _interopRequireDefault(require("react-resize-detector"));

var _api = _interopRequireDefault(require("promo-editor-services/lib/api"));

var _viewApi = _interopRequireDefault(require("promo-editor-services/lib/view-api"));

var _ratio = require("../services/ratio/ratio.service");

var _ratio2 = _interopRequireDefault(require("./shapes/ratio.shape"));

var _knownAxis = _interopRequireDefault(require("./shapes/known-axis.shape"));

var _aspectRatioBox = _interopRequireDefault(require("../aspect-ratio-box/aspect-ratio-box"));

var _fullscreen = _interopRequireDefault(require("../fullscreener/fullscreen.service"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

class RealtimePlayer extends _react.Component {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "state", {
      duration: undefined,
      knownAxis: this.props.knownAxis === 'auto' ? 'width' : this.props.knownAxis
    });
    (0, _defineProperty2.default)(this, "onCanplay", () => {
      const {
        autoplay
      } = this.props;

      if (autoplay) {
        this.videoTag.play();
      }
    });
    (0, _defineProperty2.default)(this, "setAutoAxis", () => {
      let knownAxis;

      if (this.props.knownAxis === 'auto') {
        const containerParent = this.container.parentElement;
        const parentBox = containerParent.getBoundingClientRect();
        const parentRatio = parentBox.width / parentBox.height;
        const [ratioWidth, ratioHeight] = this.getRatioNumbers();
        const containerRatio = ratioWidth / ratioHeight;
        const isParentRatioBigger = parentRatio > containerRatio;
        knownAxis = isParentRatioBigger ? 'height' : 'width';
      } else {
        knownAxis = this.props.knownAxis;
      }

      if (knownAxis !== this.state.knownAxis) {
        this.setState({
          knownAxis
        });
      }

      const containerBox = this.container.getBoundingClientRect();
      const {
        ratio: {
          width,
          height
        }
      } = this.videoData;
      let scale = containerBox.width / width;
      const newHeight = height * scale;

      if (newHeight > containerBox.height) {
        scale *= containerBox.height / newHeight;
      }

      this.viewApi.scale = scale;
    });
    (0, _defineProperty2.default)(this, "onMetadata", () => {
      this.setState({
        duration: this.videoTag.duration * 1000
      });
    });
    (0, _defineProperty2.default)(this, "getRatioNumbers", () => {
      const [ratioWidth, ratioHeight] = this.props.ratio.split(':');
      return [+ratioWidth, +ratioHeight];
    });
    (0, _reactHotkeys.configure)({
      ignoreRepeatedEventsWhenKeyHeldDown: false
    }); // configuring react-hotkeys for fixing "keypress" functionality
  }

  componentDidMount() {
    const createDefer = () => {
      const defer = {};
      defer.promise = new Promise((resolve, reject) => {
        defer.resolve = resolve;
        defer.reject = reject;
      });
      return defer;
    };

    const viewApiReadyDefer = createDefer(); // raw API

    const settings = {
      logger: console
    };
    this.editorApi = new _api.default(settings, value => {
      const {
        payload
      } = value;

      if (payload) {
        if (payload.message === 'js api.view ready') {
          viewApiReadyDefer.resolve();
        }
      }
    });
    const {
      videoUrl,
      cdn,
      callbacks,
      fonts
    } = this.props;
    this.videoData = this.editorApi.createNewPromo(videoUrl).payload;
    this.editorApi.addAPI('view', _viewApi.default, {
      domEl: this.videoTag,
      cdn,
      fonts
    });
    viewApiReadyDefer.promise.then(() => {
      console.log('js view ready let go');
      this.viewApi = this.editorApi.view;
      this.onMetadata();
      const {
        onInit
      } = callbacks;
      const {
        rendered
      } = this.state;

      if (!rendered) {
        this.setState({
          rendered: true
        });
        onInit && onInit();
      }

      this.videoTag.addEventListener('canplay', this.onCanplay);
      this.viewApi.create();

      if (this.videoTag.duration) {
        console.log('duartion', this.videoTag.duration);
        this.videoTag.dispatchEvent(new Event('loadedmetadata'));
        this.onMetadata();
      }

      this.setAutoAxis();
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.videoUrl !== this.props.videoUrl) {
      this.videoData = this.editorApi.createNewPromo(nextProps.videoUrl).payload;
      this.videoTag.pause();
      this.videoTag.currentTime = 0;
      this.viewApi.create();
      this.setState({
        duration: undefined
      });
      this.videoTag.dispatchEvent(new Event('loadedmetadata'));
      this.onMetadata();
      this.setAutoAxis();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.ratio !== this.props.ratio || prevProps.knownAxis !== this.props.knownAxis) {
      this.setAutoAxis();
    }
  }

  componentWillUnmount() {
    if (this.videoTag) {
      this.videoTag.removeEventListener('loadedmetadata', this.onMetadata);
      this.videoTag.removeEventListener('canplay', this.onCanplay);
      this.viewApi.clear();
    }
  }

  render() {
    const {
      ratio
    } = this.props;
    const _this$props = this.props,
          {
      children,
      duration,
      callbacks
    } = _this$props,
          otherProps = (0, _objectWithoutProperties2.default)(_this$props, ["children", "duration", "callbacks"]);
    const {
      knownAxis
    } = this.state;

    const childrenProps = _objectSpread({
      videoTag: this.videoTag,
      container: this.container,
      duration: this.state.duration,
      callbacks
    }, otherProps);

    if (callbacks.onShare) {
      // if we have an onShare callbacks, wrap it
      const originalOnShare = callbacks.onShare;

      callbacks.onShare = () => {
        originalOnShare(); // in addition to calling the callback, make sure we're not fullscreen

        _fullscreen.default.exit(this.container).catch(() => {});
      };
    }

    const ChildrenWithProps = children ? /*#__PURE__*/_react.default.cloneElement(children, childrenProps) : null;
    const [ratioWidth, ratioHeight] = this.getRatioNumbers();
    return /*#__PURE__*/_react.default.createElement(_aspectRatioBox.default, {
      width: ratioWidth,
      height: ratioHeight,
      knownAxis: knownAxis,
      className: (0, _classnames.default)('video-player-container', "video-player-container--ratio-".concat(_ratio.RATIOS[ratio].name), "video-player-container--known-".concat(knownAxis)),
      ref: container => {
        this.container = container;
      }
    }, /*#__PURE__*/_react.default.createElement(_reactResizeDetector.default, {
      handleWidth: true,
      handleHeight: true,
      onResize: this.setAutoAxis
    }), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)('video-tag'),
      ref: videoTag => {
        this.videoTag = videoTag;
      }
    }), ChildrenWithProps));
  }

}

(0, _defineProperty2.default)(RealtimePlayer, "propTypes", {
  children: _propTypes.default.node,
  // eslint-disable-next-line react/forbid-prop-types
  videoUrl: _propTypes.default.string,
  // can't require as sometimes its passed later with children
  ratio: _ratio2.default,
  resolution: _propTypes.default.number,
  duration: _propTypes.default.number,
  // also can't require
  callbacks: _propTypes.default.shape({
    onInit: _propTypes.default.func,
    onVolumeChange: _propTypes.default.func,
    onShare: _propTypes.default.func
  }),
  knownAxis: _knownAxis.default,
  autoplay: _propTypes.default.bool,
  cdn: _propTypes.default.string,
  fonts: _propTypes.default.shape({
    css: _propTypes.default.array,
    fonts: _propTypes.default.array
  })
});
(0, _defineProperty2.default)(RealtimePlayer, "defaultProps", {
  children: null,
  ratio: _ratio.RATIOS_BY_NAME.wide.key,
  resolution: _ratio.RATIOS_BY_NAME.wide.height,
  videoUrl: null,
  duration: undefined,
  callbacks: {},
  knownAxis: 'auto',
  autoplay: false,
  cdn: null,
  fonts: null
});
var _default = RealtimePlayer;
exports.default = _default;